<template>
  <div class="quill">
    <div :id="toolbarId">
      <span class="ql-formats">
        <select class="ql-font"></select>
        <select class="ql-header">
          <option value="2">Título 1</option>
          <option value="3">Título 2</option>
          <option value="4">Título 3</option>
          <option value="5">Título 4</option>
          <option value="6">Título 5</option>
          <option value="">Normal</option>
        </select>
      </span>
      <span class="ql-formats">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
        <button class="ql-link"></button>
        <button class="ql-image"></button>
        <button class="ql-blockquote"></button>
        <button class="ql-code"></button>
        <button type="button" class="ql-list" value="ordered"></button>
        <button type="button" class="ql-list" value="bullet"></button>
      </span>
    </div>
    <div :id="editorId" :name="name" class="editor" ref="editor"></div>
    <div style="color: #fb6340" v-show="EditorLimitReached" id="counter">
      Limite de caracteres alcançado !!
    </div>
  </div>
</template>
<script>
//import Quill from "quill";
//const limit = 200;
export default {
  name: "html-editor",
  props: {
    value: {
      type: String,
      default: ""
    },
    limitLengthText: {
      type: Number,
      default: 0
    },
    name: String
  },
  data() {
    return {
      editor: null,
      content: null,
      lastHtmlValue: "",
      editorId: null,
      toolbarId: null
    };
  },
  methods: {
    getQuillHtml() {
      return this.editor.root.innerHTML;
    },
    initialize(Quill) {
      this.editor = new Quill(`#${this.editorId}`, {
        theme: "snow",
        modules: {
          toolbar: `#${this.toolbarId}`
        },
        placeholder:
          "Descreva aqui os Documentos, Links,e demais exigências para este tipo de requerimento...."
      });

      if (this.value.length > 0) {
        this.editor.pasteHTML(this.value);
      }

      this.initializeTextChangeEvent();
      this.$emit("editorTextLength", this.editor.getLength() - 1);
    },

    initializeTextChangeEvent() {
      let editorRef = this.$refs.editor;
      let node = editorRef.children[0];
      this.editor.on("text-change", () => {
        let html = node.innerHTML;
        if (html === "<p><br></p>") {
          html = "";
        }
        if (this.editor.getLength() > this.limitLengthText) {
          // evita passar do limite de caracteres do text
          // this.editor.deleteText(this.limitLengthText, this.editor.getLength());
        }
        this.content = html;
        //this.$emit("input", this.content);
        this.$emit("input", node.innerHTML);
        this.$emit("editorTextLength", this.editor.getLength() - 1);
      });
    },

    pasteHTML() {
      if (!this.editor) {
        return;
      }
      this.editor.pasteHTML(this.value);
    },
    randomString() {
      let text = "";
      let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }
  },
  async mounted() {
    var Quill = await import("quill");
    Quill = Quill.default || Quill;
    this.editorId = this.randomString();
    this.toolbarId = this.randomString();
    this.$nextTick(() => {
      this.initialize(Quill);
    });
  },
  watch: {
    value(newVal) {
      if (newVal !== this.content) {
        this.pasteHTML(newVal);
      }
    }
  },

  computed: {
    data() {
      if (!this.editor) return "";
      return this.editor.getText();
    },
    counterTextLength() {
      return this.data.length;
    },
    EditorLimitReached() {
      return this.data.length - 1 == this.limitLengthText;
    }
  }
};
</script>

<style>
.ql-editor {
  padding-top: 0.625rem;
  padding-right: 1.75rem;
  padding-bottom: 2.625rem;
  padding-left: 0.75rem;
}
</style>
